import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=373ab9b6&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=373ab9b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ab9b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373ab9b6')) {
      api.createRecord('373ab9b6', component.options)
    } else {
      api.reload('373ab9b6', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=373ab9b6&scoped=true&", function () {
      api.rerender('373ab9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BNkCj2ai434F/JS/comp/Paginate.vue"
export default component.exports